import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
  PaginationItem,
  Grid,
  Collapse,
  Divider,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { useTheme } from '@emotion/react';
import LocationPickerMap from 'src/components/LocationPickerMap';
import GooglePlaces from 'src/components/GooglePlaces';
import dayjs from 'dayjs';

export default function MyTrucks() {
  const theme = useTheme();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));

  const [origin, setOrigin] = useState('');
  const [dhO, setDhO] = useState('');
  const [destination, setDestination] = useState('');
  const [dhD, setDhD] = useState('');
  const [equipmentType, setEquipmentType] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loadType, setLoadType] = useState('');
  const [length, setLength] = useState('');
  const [weight, setWeight] = useState('');
  const [ageInHours, setAgeInHours] = useState('');
  const [company, setCompany] = useState('');
  console.log('🚀 ~ MyTrucks ~ company:', company);
  const [length_unit, setLength_unit] = useState('ft');
  const [weight_unit, setWeight_unit] = useState('kg');

  const [isFilled, setIsFilled] = useState(false);
  const [isSearchFilled, setIsSearchFilled] = useState(false);

  const [openCompany, setOpenCompany] = useState(false);
  const [openRequirmentModal, setOpenRequirmentModal] = useState(false);
  const [openSearchBack, setOpenSearchBack] = useState(false);
  const [reSearch, setReSearch] = useState(false);

  const [loading, setloading] = useState(false);
  const [trucksList, setTrucksList] = useState([]);
  const [optionsLoader, setOptionsLoader] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [equipmentList, setEquipmentList] = useState([]);
  const [compnayList, setCompnayList] = useState([]);

  const [mapOpen, setMapOpen] = useState(false);
  const [locationType, setLocationType] = useState(''); // 'origin' or 'destination'

  const [selected, setSelected] = useState([]); // To hold selected truck objects
  const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
  const [selectedTruck, setSelectedTruck] = useState(null); // Track which truck is selected for menu

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [clearFilterTrigger, setClearFilterTrigger] = useState(false);

  const [optionNumber, setOptionNumber] = useState('');
  const [openAlertModal, setOpenAlertModal] = useState(false);

  const [selectLoad, setSelectLoad] = useState('');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  useEffect(() => {
    getEquipments();
    getTruckList(1);
  }, []);

  useEffect(() => {
    getTruckList(1);
  }, [company, origin, destination]);

  useEffect(() => {
    if (clearFilterTrigger) {
      getTruckList(1);
      setClearFilterTrigger(false); // Reset kar dete hain taake ye baar baar trigger na ho
    }
  }, [clearFilterTrigger]);

  useEffect(() => {
    if (reSearch) {
      getTruckList(1);
    }
  }, [reSearch]);

  function getCompanyList() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_companies, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCompnayList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function getEquipments() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_equipments, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEquipmentList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  useEffect(() => {
    getTruckList(page);
  }, [page]);

  function getTruckList(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    origin?.address && queryParams.append('location_origin', origin?.address); // Required
    origin?.country && queryParams.append('country_origin', origin?.country); // Optional
    origin?.city && queryParams.append('city_origin', origin?.city); // Optional
    origin?.state && queryParams.append('state_origin', origin?.state); // Optional
    origin?.lat && queryParams.append('lat_origin', origin?.lat); // Required
    origin?.lon && queryParams.append('lon_origin', origin?.lon); // Required
    origin?.zone && queryParams.append('zone_origin', origin?.zone); // Required
    origin?.zip_code && queryParams.append('zip_code_origin', origin?.zip_code); // Required
    dhO && queryParams.append('dho', dhO);
    destination?.address && queryParams.append('location_destination', destination?.address); // Required
    destination?.country && queryParams.append('country_destination', destination?.country); // Optional
    destination?.city && queryParams.append('city_destination', destination?.city); // Optional
    destination?.state && queryParams.append('state_destination', destination?.state); // Optional
    destination?.lat && queryParams.append('lat_destination', destination?.lat); // Required
    destination?.lon && queryParams.append('lon_destination', destination?.lon); // Required
    destination?.zone && queryParams.append('zone_destination', destination?.zone); // Required
    destination?.zip_code && queryParams.append('zip_code_destination', destination?.zip_code);
    dhD && queryParams.append('dhd', dhD);
    length_unit && length && queryParams.append('length_unit', length_unit);
    weight_unit && weight && queryParams.append('weight_unit', weight_unit);
    equipmentType && queryParams.append('equipment_id', equipmentType);
    startDate && queryParams.append('pickup_earliest', moment(startDate).format('YYYY-MM-DD'));
    endDate && queryParams.append('pickup_lattest', moment(endDate).format('YYYY-MM-DD'));
    loadType && queryParams.append('equipment_type', loadType);
    length && queryParams.append('length_ft', length);
    weight && queryParams.append('weight_lbs', weight);
    ageInHours && queryParams.append('age', ageInHours);
    company && queryParams.append('company', company);

    fetch(`${api.get_trucks}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setTrucksList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setTrucksList([]);
          setpagesCount(0);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  const handleStartDateChange = (value) => {
    setStartDate(value ? value.toISOString() : null);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value ? value.toISOString() : null);
  };

  const [searchLoadList, setSearchLoadList] = useState([]);

  // Detail Dialog Handlers
  const handleOpenDetailsModal = (row) => {
    setOpenDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
  };

  // open company modal
  const handleOpenCompany = () => setOpenCompany(true);
  const handleCloseCompany = () => {
    setOpenCompany(false);
  };

  // requirment modal
  const handleOpenRequirmentModal = () => setOpenRequirmentModal(true);
  const handleCloseRequirmentModal = () => {
    setOpenRequirmentModal(false);
    setLoadType('');
    setLength('');
    setWeight('');
  };

  // Search Back Dialog Handlers
  const handleOpenSearchBack = () => setOpenSearchBack(true);
  const handleCloseSearchBack = () => {
    setOpenSearchBack(false);
    setAgeInHours('');
  };

  const handleClearAllSearchBack = () => {
    setAgeInHours('');
    setReSearch('2');
    setIsSearchFilled(false);
    setOpenSearchBack(false);
    getTruckList(1);
  };

  const handleDoneSearchBack = () => {
    if (ageInHours) {
      setIsSearchFilled(true);
      setOpenSearchBack(false);
      setReSearch('');
      getTruckList(1);
    } else {
      setIsSearchFilled(false);
      setOpenSearchBack(false);
      setReSearch('');
    }
  };

  // Handle clearing selected Requirment
  const handleClearAll = () => {
    setLoadType('');
    setLength('');
    setWeight('');
    setReSearch('1');
    setIsFilled(false);
    setOpenRequirmentModal(false);
    getTruckList(1);
  };

  // Handle Done Requirment
  const handleDoneLoad = () => {
    if (loadType || length || weight) {
      setIsFilled(true);
      setOpenRequirmentModal(false);
      setReSearch('');
      getTruckList(1);
    } else {
      setIsFilled(false);
      setOpenRequirmentModal(false);
      setReSearch('');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'length') {
      if (e.target.value.length <= 7) {
        setLength(value);
      }
    }
    if (name === 'weight') {
      if (e.target.value.length <= 7) {
        setWeight(value);
      }
    }
  };

  const handlePageChange = (event, value) => {
    trucksList.length = 0;
    setPage(value);
    getTruckList(value);
  };

  const handleClearFilter = () => {
    setPage(1);
    setOrigin(''); // Reset origin here
    setDhO('');
    setDhD('');
    setDestination('');
    setEquipmentType('');
    setStartDate(null);
    setEndDate(null);
    setLoadType('');
    setLength('');
    setWeight('');
    setAgeInHours('');
    setCompany('');
    setClearFilterTrigger(true);
    setIsFilled(false);
    setIsSearchFilled(false);
  };

  // Handle clearing selected comapny
  const clearSelectionCompany = () => {
    setCompany('');
    handleCloseCompany();
    setReSearch('3');
    getTruckList(1);
  };

  const handleCompanyClick = (zone) => {
    setCompany(zone); // Set selected zone in input field
    handleCloseCompany(); // Close modal after selection
    setReSearch('');
    getTruckList(1);
  };

  const handleLocationIconClick = (type) => {
    setLocationType(type);
    setMapOpen(true);
  };

  const handleSelectLocation = (type, locationData) => {
    if (type === 'origin') {
      setOrigin(locationData);
    } else if (type === 'destination') {
      setDestination(locationData);
    }
    setMapOpen(false);
  };

  useEffect(() => {
    getTruckList(page);
  }, [page]);

  // const isAllSelected = selected.length === trucksList.length;
  const isAllSelected =
    selected.length ===
    trucksList.filter((truck) => truck?.status.toLowerCase() !== 'expired').length;

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Toggle individual row selection
  const handleSelectRow = (truck) => {
    const selectedIndex = selected.findIndex((item) => item === truck);

    if (selectedIndex > -1) {
      setSelected(selected.filter((item) => item !== truck)); // Deselect if already selected
    } else {
      setSelected([...selected, truck]); // Add truck to selected array
    }
  };

  // Toggle select all rows
  const handleSelectAll = () => {
    const nonExpiredShipments = trucksList.filter(
      (truck) => truck?.status.toLowerCase() !== 'expired'
    );
    if (isAllSelected) {
      setSelected([]); // Deselect all
    } else {
      setSelected(nonExpiredShipments); // Select only non-expired trucks
    }
  };

  const handleMenuClick = (event, truck) => {
    setAnchorEl(event.currentTarget);
    setSelectedTruck(truck); // Set the truck for which menu is open
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTruck(null); // Reset the selected truck
  };

  const handleOptionSelect = (option) => {
    setOptionNumber(option);
    if (selected.length == 0) {
      ChangeTruckStatus(option);
    } else {
      ChangeBulkTruckStatus(option);
    }
  };

  // change_truck_status
  function ChangeTruckStatus(status) {
    setOptionsLoader(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    selected && formdatas.append('id', selectedTruck?.id);
    formdatas.append('status', status);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.change_truck_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setOptionsLoader(false);
          handleMenuClose();
          handleCloseAlert();
          getTruckList(page);
          setOptionNumber('');
        } else {
          setOptionsLoader(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setOptionsLoader(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // change_bulk_truck_status
  function ChangeBulkTruckStatus(status) {
    setOptionsLoader(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    if (selected && selected.length > 0) {
      const selectedIds = selected.map((item) => item.id);
      formdatas.append('ids', selectedIds);
    }
    formdatas.append('status', status);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.change_bulk_truck_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setOptionsLoader(false);
          setSelected([]);
          handleMenuClose();
          getTruckList(page);
          setOptionNumber('');
        } else {
          setOptionsLoader(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setOptionsLoader(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  const handleOpenAlert = () => {
    setOpenAlertModal(true);
  };

  const handleCloseAlert = () => {
    setOpenAlertModal(false);
  };

  const [expandedRow, setExpandedRow] = useState(null);
  const handleRowClick = (rowIndex) => {
    setExpandedRow((prevIndex) => (prevIndex === rowIndex ? null : rowIndex));
  };

  return (
    <Page title={`My Trucks  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            My Trucks
          </Typography>
          {userData?.role?.id !== 6 && (
            <Button
              variant="contained"
              component={RouterLink}
              to="/dashboard/my_trucks/form"
              startIcon={<Iconify icon="mdi:truck-plus-outline" style={{ fontSize: 19 }} />}
              sx={{ alignSelf: 'end', fontSize: 11 }}
            >
              Add New Truck
            </Button>
          )}
        </Stack>

        <Box sx={{ flexGrow: 1, marginTop: 2 }}>
          <Grid container spacing={1} alignItems="flex-start" justifyContent="space-between" mb={2}>
            {/* Origin Field */}
            <Grid item xs={12} sm={4.3} md={4.3}>
              <GooglePlaces
                width={'100%'}
                onResult={(val) => {
                  setOrigin(val);
                }}
                placeholder={'Origin'}
                // regions={true}
                address={origin?.address} // Ensure origin updates here
                stylePinIcon={{ fontSize: 12 }}
                styleCountryText={{ fontSize: 10 }}
                styleCityText={{ fontSize: 9 }}
                boxCountryCity={{ width: 20, paddingTop: 0 }}
              />
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 5
                }}
                onClick={() => handleLocationIconClick('origin')}
              >
                <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
              </div>
            </Grid>

            {/* DH-O Field */}
            <Grid item xs={12} sm={1.3} md={1.3}>
              <TextField
                label="DH-O"
                type="number"
                value={dhO}
                onChange={(e) => {
                  if (e.target.value.length <= 4) {
                    setDhO(e.target.value);
                  }
                }}
                fullWidth
                className="custom-textfield"
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                    e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                  }
                }}
              />
            </Grid>

            <Grid item mt={1.7}>
              <Iconify icon={'fa6-solid:right-left'} sx={{ fontSize: 12 }} />
            </Grid>

            {/* Destination Field */}
            <Grid item xs={12} sm={4.3} md={4.3}>
              <GooglePlaces
                width={'100%'}
                onResult={(val) => setDestination(val)}
                placeholder={'Destination'}
                // regions={true}
                address={destination?.address}
                stylePinIcon={{ fontSize: 12 }}
                styleCountryText={{ fontSize: 10 }}
                styleCityText={{ fontSize: 9 }}
                boxCountryCity={{ width: 20, paddingTop: 0 }}
              />
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 5
                }}
                onClick={() => handleLocationIconClick('destination')}
              >
                <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
              </div>
            </Grid>

            {/* DH-D Field */}
            <Grid item xs={12} sm={1.3} md={1.3}>
              <TextField
                label="DH-D"
                type="number"
                value={dhD}
                onChange={(e) => {
                  if (e.target.value.length <= 4) {
                    setDhD(e.target.value);
                  }
                }}
                fullWidth
                className="custom-textfield"
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                    e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                  }
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} xs={13}>
            <Grid item spacing={2} xs={6}>
              <Grid item mb={2} xs={12}>
                <TextField
                  label="Origin/City"
                  type="text"
                  value={origin?.city || ''}
                  onChange={(e) =>
                    setOrigin((prev) => ({
                      ...prev,
                      city: e.target.value // ✅ yahan update hoga
                    }))
                  }
                  fullWidth
                  className="custom-textfield"
                />
              </Grid>

              <Grid item container spacing={2} xs={12} md={12}>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Origin/State"
                    type="text"
                    value={origin?.state || ''}
                    onChange={(e) =>
                      setOrigin((prev) => ({
                        ...prev,
                        state: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Origin/Zip Code"
                    type="text"
                    value={origin?.zip_code || ''}
                    onChange={(e) => {
                      setOrigin((prev) => ({
                        ...prev,
                        zip_code: e.target.value // ✅ yahan update hoga
                      }));
                    }}
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item spacing={2} xs={6}>
              <Grid item mb={2} xs={12}>
                <TextField
                  label="Destination/City"
                  type="text"
                  value={destination?.city || ''}
                  onChange={(e) =>
                    setDestination((prev) => ({
                      ...prev,
                      city: e.target.value // ✅ yahan update hoga
                    }))
                  }
                  fullWidth
                  className="custom-textfield"
                />
              </Grid>
              <Grid item container spacing={2} xs={12} md={12}>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Destination/State"
                    type="text"
                    value={destination?.state || ''}
                    onChange={(e) =>
                      setDestination((prev) => ({
                        ...prev,
                        state: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item mb={2} xs={6} md={6}>
                  <TextField
                    label="Destination/Zip Code"
                    type="text"
                    value={destination?.zip_code || ''}
                    onChange={(e) =>
                      setDestination((prev) => ({
                        ...prev,
                        zip_code: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={1} alignItems="center" justifyContent="space-between" mb={2}>
            {/* Equipment Type Field */}
            <Grid item xs={12} sm={5.8} md={4.5}>
              <TextField
                select
                label="Equipment Type"
                value={equipmentType}
                onChange={(e) => setEquipmentType(e.target.value)}
                fullWidth
                // error={Boolean(errors.equipmentType)}
                // helperText={errors.equipmentType}
                InputLabelProps={{
                  shrink: true, // Force the label to shrink when a value is selected
                  style: {
                    fontSize: '11px',
                    lineHeight: '1.2',
                    transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                  }
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        paddingTop: 0 // Ensure the dropdown aligns properly
                      }
                    }
                  }
                }}
                InputProps={{
                  style: {
                    fontSize: 14,
                    height: '50px', // Set the height of the input field
                    padding: '0px 0px' // Add padding to input field
                  }
                }}
              >
                {equipmentList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <span
                        style={{
                          flex: 1,
                          textAlign: 'start',
                          display: 'flex',
                          fontWeight: 'normal',
                          marginRight: 10,
                          fontSize: 14
                        }}
                      >
                        {option.name}
                      </span>
                      <span
                        style={{
                          flex: 1,
                          width: '100%',
                          textAlign: 'right',
                          fontWeight: 'bold',
                          fontSize: 14,
                          color: '#000'
                        }}
                      >
                        {option.code}
                      </span>
                    </div>
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Date Range Field */}
            <Grid item xs={12} sm={4.5} md={5.3} sx={{ marginTop: -1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={['DatePicker']}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row'
                  }}
                >
                  <Grid item>
                    <DatePicker
                      className="custom-textfield"
                      label="Start Date"
                      value={startDate ? dayjs(startDate) : null}
                      onChange={(newValue) => handleStartDateChange(newValue)}
                      // minDate={dayjs()}
                    />
                  </Grid>
                  <Grid item>
                    <DatePicker
                      className="custom-textfield"
                      label="End Date"
                      value={endDate ? dayjs(endDate) : null}
                      onChange={(newValue) => handleEndDateChange(newValue)}
                    />
                  </Grid>
                </DemoContainer>
              </LocalizationProvider>
            </Grid>

            {/* Search Button */}
            <Grid item xs={12} sm={4.5} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 40, width: '100%' }}
                onClick={() => getTruckList(1)}
              >
                <SearchIcon />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4.5} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 40, width: '100%' }}
                onClick={handleClearFilter}
              >
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Buttons */}
        <Grid container spacing={2}>
          <Grid
            item
            display={'flex'}
            position={'relative'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={handleOpenRequirmentModal}
              style={{
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                fontSize: 10,
                height: 20,
                borderRadius: 100,
                backgroundColor: isFilled ? theme.palette.primary.main : '#F0F0F9',
                color: isFilled ? 'white' : theme.palette.text.primary,
                border: isFilled ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Load Requirements
            </Button>
            {isFilled && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  handleClearAll();
                  // setReSearch('1');
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>

          <Grid
            item
            position={'relative'}
            display={'flex'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={handleOpenSearchBack}
              style={{
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                fontSize: 10,
                height: 20,
                borderRadius: 100,
                backgroundColor: isSearchFilled ? theme.palette.primary.main : '#F0F0F9',
                color: isSearchFilled ? 'white' : theme.palette.text.primary,
                border: isSearchFilled ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Search Back - 24 hrs
            </Button>
            {isSearchFilled && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  handleClearAllSearchBack();
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>

          <Grid
            item
            position={'relative'}
            display={'flex'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setCompnayList([]);
                getCompanyList();
                handleOpenCompany();
              }}
              style={{
                fontSize: 10,
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                height: 20,
                borderRadius: 100,
                backgroundColor: company ? theme.palette.primary.main : '#F0F0F9',
                color: company ? 'white' : theme.palette.text.primary,
                border: company ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Company
            </Button>
            {company && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  // handleClearAllCompany();
                  clearSelectionCompany();
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>
        </Grid>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {!loading && trucksList.length !== 0 && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      size="small"
                      checked={isAllSelected}
                      indeterminate={selected.length > 0 && selected.length < trucksList.length}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                )}
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AGE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRUCK</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AVAILABLE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: '200px' }}>
                  MATCHES
                </TableCell>
                {userData?.role?.id == 6 && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                )}
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 68,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 110
                  }}
                >
                  STATUS
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 80
                  }}
                  align="right"
                >
                  {selected.length > 0 && (
                    <>
                      <IconButton
                        onClick={handleMenuClick}
                        style={{ marginTop: -7, marginBottom: -7 }}
                      >
                        <Iconify icon="iwwa:option" style={{ fontSize: 20 }} />
                      </IconButton>
                      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        <MenuItem sx={{ fontSize: 12 }} onClick={() => handleOptionSelect('1')}>
                          {optionsLoader && optionNumber == '1' ? (
                            <CircularProgress size={12} />
                          ) : (
                            'Post'
                          )}
                        </MenuItem>
                        <MenuItem sx={{ fontSize: 12 }} onClick={() => handleOptionSelect('2')}>
                          {optionsLoader && optionNumber == '2' ? (
                            <CircularProgress size={12} />
                          ) : (
                            'Unpost'
                          )}
                        </MenuItem>
                        <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenAlert}>
                          Delete
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {trucksList.map((truck, index) => {
                  return (
                    <>
                      <TableRow
                        key={index}
                        onClick={() => {
                          handleRowClick(index);
                          setSelectLoad(truck);
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={selected.includes(truck)}
                            onChange={() => handleSelectRow(truck)}
                            disabled={truck?.status.toLowerCase() == 'expired' ? true : false}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 20 }}>{truck?.age}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography style={{ fontSize: 12, width: 180 }}>
                            {`${truck?.equipment_type || '-'} | ${truck?.equipment_name || '-'} | ${
                              truck?.weight_lbs || '-'
                            } ${truck?.weight_unit || '-'} | ${truck?.length_ft || '-'} ${
                              truck?.length_unit || '-'
                            }`}
                            {/* Flatbed | 42k lbs | 48ft | Full */}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {truck?.available}
                          <Typography style={{ fontSize: 12, width: 75 }}>
                            {moment(truck?.startdate).format('MM/DD/YYYY')} -{' '}
                            {moment(truck?.enddate).format('MM/DD/YYYY')}
                          </Typography>
                          {/* 7/24 - 7/26 */}
                        </TableCell>

                        <TableCell sx={{ fontSize: '12px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start'
                            }}
                          >
                            <p
                              style={{
                                fontWeight: 'bold',
                                color: '#010f58',
                                marginRight: 5,
                                fontSize: 10
                              }}
                            >
                              {truck?.total_mil || '-'}
                            </p>
                            <div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginBottom: -5
                                }}
                              >
                                <div
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 100,
                                    backgroundColor: 'white',
                                    border: '2px solid #010f58',
                                    marginRight: 5
                                  }}
                                ></div>
                                <p
                                  style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '150px' // Adjust this width as needed
                                  }}
                                >
                                  {truck?.location_origin}
                                </p>
                              </div>
                              <div>
                                <Iconify
                                  icon="mingcute:arrow-down-line"
                                  style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                                />
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginTop: -10
                                }}
                              >
                                <div
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 100,
                                    backgroundColor: '#010f58',
                                    border: '2px solid #010f58',
                                    marginRight: 5
                                  }}
                                ></div>
                                <p
                                  style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '150px' // Adjust this width as needed
                                  }}
                                >
                                  {truck?.location_destination}
                                </p>
                              </div>
                            </div>
                          </div>
                        </TableCell>

                        <TableCell>
                          {truck.rate ? (
                            <NumericFormat
                              value={truck.rate ? parseFloat(truck.rate).toFixed(2) : '0.00'}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'$'}
                              style={{ fontSize: '12px' }}
                            />
                          ) : (
                            '-'
                          )}
                        </TableCell>

                        <TableCell align="center" style={{ width: 150 }}>
                          <IconButton
                            // style={{ padding: 5 }}
                            // onClick={() => {
                            //   navigate('/dashboard/my_trucks/request_a_shipment');
                            // }}
                            component={RouterLink}
                            to="/dashboard/my_trucks/request_a_shipment"
                            state={{ truck_id: truck?.id }}
                          >
                            <Iconify
                              icon={'streamline:shipment-download-solid'}
                              sx={{
                                color: '#010f58',
                                width: 20,
                                height: 20,
                                cursor: 'pointer'
                              }}
                            />
                          </IconButton>
                        </TableCell>

                        {userData?.role?.id == 6 && (
                          <TableCell sx={{ fontSize: '12px' }}>
                            <RouterLink
                              className="routerLink"
                              onClick={() => {
                                handleOpenDetailsModal();
                                setSelectLoad(truck);
                              }}
                            >
                              {truck.company.company
                                ? truck.company.company
                                : truck.company.first_name + ' ' + truck.company.last_name}
                            </RouterLink>
                          </TableCell>
                        )}

                        <TableCell
                          align="left"
                          style={{
                            position: 'sticky',
                            right: 68,
                            zIndex: 1,
                            background: '#fff'
                          }}
                        >
                          <Typography
                            className={
                              (truck?.status.toLowerCase() == 'posted' && 'status-green') ||
                              (truck?.status.toLowerCase() == 'unposted' && 'status-blue') ||
                              (truck.status.toLowerCase() == 'pending' && 'status-blue') ||
                              (truck?.status.toLowerCase() == 'expired' && 'status-red') ||
                              (truck?.status.toLowerCase() == 'deleted' && 'status-red')
                            }
                          >
                            {truck?.status || 'N/A'}
                          </Typography>
                        </TableCell>

                        {truck?.status.toLowerCase() !== 'expired' && (
                          <TableCell
                            align="right"
                            style={{
                              position: 'sticky',
                              right: 0,
                              zIndex: 1,
                              background: '#fff'
                            }}
                          >
                            {/* Show row-specific 3-dot menu only if no bulk action is active */}
                            {selected.length === 0 && (
                              <IconButton onClick={(e) => handleMenuClick(e, truck)}>
                                <Iconify
                                  icon="iwwa:option"
                                  style={{ fontSize: 20, color: '#010f58' }}
                                />
                              </IconButton>
                            )}
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl) && selectedTruck === truck}
                              onClose={handleMenuClose}
                            >
                              <MenuItem
                                sx={{ fontSize: 12 }}
                                onClick={() =>
                                  handleOptionSelect(
                                    truck?.status.toLowerCase() == 'posted' ? '2' : '1'
                                  )
                                }
                              >
                                {optionsLoader ? (
                                  <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                                ) : truck?.status.toLowerCase() == 'posted' ? (
                                  'Unpost'
                                ) : (
                                  'Post'
                                )}
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: 12 }}
                                component={RouterLink}
                                to="/dashboard/my_trucks/view_details"
                                state={{ viewOnly: true, detail_id: truck?.id }}
                              >
                                View Details
                              </MenuItem>

                              {/* {truck?.bid_request && ( */}
                              <MenuItem
                                sx={{ fontSize: 12 }}
                                component={RouterLink}
                                to="/dashboard/my_trucks/truck_request"
                                state={{ shipment_id: truck?.id }}
                                // onClick={() => handleOpenRequest(truck.id)}
                              >
                                View Requests
                              </MenuItem>
                              {/* )} */}

                              <MenuItem
                                sx={{ fontSize: 12 }}
                                component={RouterLink}
                                to="/dashboard/my_trucks/edit_truck"
                                state={{ viewOnly: false, detail_id: truck?.id, data: truck }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenAlert}>
                                Delete
                              </MenuItem>

                              {truck.status.toLowerCase() !== 'pending' && (
                                <MenuItem
                                  sx={{ fontSize: 12 }}
                                  component={RouterLink}
                                  to="/dashboard/my_trucks/add_document"
                                  state={{ shipmentDetail: truck, type: 'truck' }}
                                >
                                  Upload Document
                                </MenuItem>
                              )}
                              {truck.status.toLowerCase() == 'posted' && (
                                <MenuItem
                                  sx={{ fontSize: 12 }}
                                  component={RouterLink}
                                  to="/dashboard/my_trucks/request_to_company"
                                  state={{ truck_id: truck?.id }}
                                >
                                  Shipper Profiles
                                </MenuItem>
                              )}
                            </Menu>
                          </TableCell>
                        )}
                      </TableRow>

                      <TableRow style={{ display: expandedRow !== index && 'none' }}>
                        <TableCell
                          style={{ backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 }}
                          colSpan={11}
                        >
                          <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                            <Grid container spacing={2} mb={2} style={{ height: '30%' }}>
                              {/* Trip Section */}
                              <Grid item xs={12} sm={6} style={{ position: 'relative' }}>
                                {/* Header */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    TRIP
                                  </p>
                                </Box>

                                {/* Content Section */}
                                <Box
                                  style={{
                                    marginTop: 2,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    position: 'relative'
                                  }}
                                >
                                  {/* Row 1 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:dot-square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.location_origin}
                                    </Typography>
                                  </Box>

                                  {/* Row 2 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.location_destination}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Vertical Icons */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    position: 'absolute',
                                    top: 70,
                                    left: 26.5
                                  }}
                                >
                                  {Array(4)
                                    .fill(null)
                                    .map((_, idx) => (
                                      <Iconify
                                        key={idx}
                                        icon="pepicons-pop:line-y"
                                        style={{
                                          fontSize: 7, // Fixed line size
                                          color: '#010f58',
                                          marginBottom: 3
                                        }}
                                      />
                                    ))}
                                  <Iconify
                                    icon="ion:arrow-down-outline"
                                    style={{
                                      fontSize: 11, // Fixed arrow size
                                      color: '#010f58'
                                    }}
                                  />
                                </Box>
                              </Grid>

                              {/* Details Section */}
                              <Grid item xs={12} sm={6}>
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    DETAILS
                                  </p>
                                </Box>

                                <Box
                                  style={{
                                    paddingLeft: 10,
                                    paddingRight: 10
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Equipment Type :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.equipment_type || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Length :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {`${selectLoad.length_ft}/${selectLoad?.length_unit}` || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Weight :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {`${selectLoad.weight_lbs}/${selectLoad?.weight_unit}` || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Rate :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.rate || '-'}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Equipment Name :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.equipment_name || '-'}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Reference ID :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.reference_id || '-'}
                                    </Typography>
                                  </Box>

                                  {/* <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      DHO | DHD :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.dhO && selectLoad?.dhd
                                        ? `${selectLoad?.dhO} | ${selectLoad?.dhd}`
                                        : '-'}
                                    </Typography>
                                  </Box> */}

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        width: '17%',
                                        color: 'grey',
                                        fontSize: 12
                                      }}
                                    >
                                      Comment :
                                    </Typography>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        marginLeft: 20,
                                        flex: 1
                                      }}
                                    >
                                      {selectLoad?.comments || '-'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {trucksList.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="60vh"
                    >
                      <img
                        src={Empty_Truck}
                        alt="No Trucks"
                        style={{ width: '150px', marginBottom: '20px', marginRight: 40 }}
                      />
                      <Typography variant="h5" gutterBottom>
                        You haven't added any trucks yet
                      </Typography>
                      <Typography variant="body1" color="textSecondary" gutterBottom>
                        Add and save truck details that can be used to save time when creating new
                        posts.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && trucksList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Dialog open={openDetailsModal} onClose={handleCloseDetailsModal} fullWidth>
          <DialogTitle
            style={{
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingLeft: 20,
              paddingRight: 10,
              marginBottom: 0
            }}
          >
            Company Information
            <IconButton onClick={handleCloseDetailsModal}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers style={{ paddingLeft: 20, paddingTop: 0 }}>
            {/* <Box sx={{ mt: 2 }}>
              <Box> */}
            <Grid
              container
              sx={{
                marginTop: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start'
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Name :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>
                  {selectLoad?.company?.company
                    ? selectLoad?.company?.company
                    : selectLoad?.company?.first_name + ' ' + selectLoad?.company?.last_name}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Email :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>{selectLoad?.company?.email}</Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Score :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>{selectLoad?.company?.score}</Typography>
              </Box>
            </Grid>
            {/* </Box>
            </Box> */}
          </DialogContent>
        </Dialog>

        <Dialog
          open={openAlertModal}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAlert} color="primary">
              No
            </Button>
            <LoadingButton
              variant="contained"
              loading={optionsLoader}
              onClick={() => {
                handleOptionSelect('4');
              }}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        {/* COMPANY MODAL */}
        <Dialog open={openCompany} onClose={handleCloseCompany} fullWidth maxWidth="sm">
          <DialogTitle style={{ height: 50 }}>
            Company
            <Button
              onClick={clearSelectionCompany}
              variant="contained"
              startIcon={<Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />}
              sx={{ alignSelf: 'end', fontSize: 11, float: 'right' }}
            >
              Clear
            </Button>
          </DialogTitle>

          <DialogContent>
            {compnayList.length == 0 && openCompany ? (
              <Box
                py={2}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flex: 1
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                {compnayList.map((val) => (
                  <Grid item xs={12} key={val?.id} sx={{ marginBottom: 1 }}>
                    <Button
                      fullWidth
                      variant={company == val?.id ? 'contained' : 'outlined'}
                      onClick={() => handleCompanyClick(val?.id)}
                      sx={{ display: 'flex', alignItems: 'flex-start' }}
                    >
                      <Typography
                        sx={{
                          flex: 1,
                          fontSize: 13,
                          textAlign: 'left'
                        }}
                      >
                        {val?.company ? val?.company : val?.first_name + ' ' + val?.last_name}
                      </Typography>
                    </Button>
                  </Grid>
                ))}
              </>
            )}
          </DialogContent>
        </Dialog>

        {/* REQUIRMENT MODAL */}
        <Dialog
          open={openRequirmentModal}
          onClose={handleCloseRequirmentModal}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle style={{ height: 50 }}>
            Load Requirements
            <IconButton
              onClick={handleCloseRequirmentModal}
              sx={{ alignSelf: 'end', float: 'right' }}
            >
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Load Type Radio Buttons */}
            <FormControl fullWidth>
              <RadioGroup
                value={loadType}
                onChange={(e) => setLoadType(e.target.value)}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  marginBottom: -1
                }}
              >
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="All"
                  control={<Radio size="small" />}
                  label={
                    <Typography style={{ fontSize: '12px', color: '#010f58' }}>All</Typography>
                  }
                />
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="Full"
                  control={<Radio size="small" />}
                  label={
                    <Typography style={{ fontSize: '12px', color: '#010f58' }}>Full</Typography>
                  }
                />
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="Partial"
                  control={<Radio size="small" />}
                  label={
                    <Typography style={{ fontSize: '12px', color: '#010f58' }}>Partial</Typography>
                  }
                />
              </RadioGroup>
            </FormControl>

            {/* Length Input */}
            <TextField
              name="length"
              label={`Length (${length_unit}.) `}
              value={length}
              onChange={handleChange}
              fullWidth
              margin="normal"
              type="number"
              className="custom-textfield"
              sx={{ marginBottom: 0 }}
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
              InputProps={{
                endAdornment: (
                  <select
                    value={length_unit} // Default to "ft" if not set
                    onChange={(e) => setLength_unit(e.target.value)}
                    style={{
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 12
                    }}
                  >
                    <option value="ft">ft</option>
                    <option value="m">m</option>
                  </select>
                )
              }}
            />

            {/* Weight Input */}
            <TextField
              name="weight"
              label={`Weight (${weight_unit}.)`}
              value={weight}
              onChange={handleChange}
              fullWidth
              margin="normal"
              type="number"
              className="custom-textfield"
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
              InputProps={{
                endAdornment: (
                  <select
                    value={weight_unit} // Default to "ft" if not set
                    onChange={(e) => setWeight_unit(e.target.value)}
                    style={{
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 12
                    }}
                  >
                    <option value="kg">kg</option>
                    <option value="lbs">lbs</option>
                  </select>
                )
              }}
            />
          </DialogContent>

          <DialogActions style={{ height: 50, marginTop: -10 }}>
            {/* Buttons in Dialog */}
            <Button onClick={handleClearAll} color="primary">
              Clear All
            </Button>
            <Button onClick={handleDoneLoad} variant="contained" color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>

        {/* Search Back Dialog */}
        <Dialog open={openSearchBack} onClose={handleCloseSearchBack} maxWidth="xs" fullWidth>
          <DialogTitle style={{ height: 40 }}>
            Search Book
            <IconButton onClick={handleCloseSearchBack} sx={{ alignSelf: 'end', float: 'right' }}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Age in Hours Input */}
            <TextField
              type="number"
              label="Age in hours"
              value={ageInHours}
              onChange={(e) => setAgeInHours(e.target.value)}
              fullWidth
              margin="normal"
              className="custom-textfield"
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
            />
            {/* Text Below Input */}
            <Typography
              style={{ fontSize: 12, marginLeft: 13, marginTop: -5 }}
              color="textSecondary"
              margin="normal"
            >
              Searches back in hours from the current time
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClearAllSearchBack} color="primary">
              Clear All
            </Button>
            <Button onClick={handleDoneSearchBack} variant="contained" color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>

        {/* Map Dialog */}
        <Dialog open={mapOpen} onClose={() => setMapOpen(false)} maxWidth="md" fullWidth>
          <DialogContent>
            <LocationPickerMap
              open={mapOpen}
              onClose={() => setMapOpen(false)}
              locationType={locationType}
              selectedLocationFromForm={locationType === 'origin' ? origin : destination}
              onSelectLocation={handleSelectLocation}
            />
          </DialogContent>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
